import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import { APIHandler, BackButton, PremiumHotel, FreeHotel } from "C4";
import { baseAppId } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Multiselect } from "multiselect-react-dropdown";
import i18n from "i18n-react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";
import logo from "assets/images/logo/logo_textwhite.png";

const directoryUrlParams = new URLSearchParams(window.location.search);

function parseQueryBool(value) {
  if (value == null || value === "") return false;
  if (value === "true" || value === "1") return true;
  if (value === "false" || value === "0") return false;
  try {
    return JSON.parse(value) === true;
  } catch {
    return false;
  }
}

let containerStyle = {
  width: "100%",
  height: "100%",
};
if (directoryUrlParams.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const checkboxOptions = [
  { name: "Arts & Entertainment", id: "Arts & Entertainment" },
  { name: "Convention Services", id: "Convention Services" },
  { name: "Diving & Snorkeling", id: "Diving & Snorkeling" },
  { name: "Film", id: "Film" },
  { name: "FitLauderdale", id: "FitLauderdale" },
  { name: "Hotels", id: "Hotels" },
  { name: "LGBT+: Gyms and Spas", id: "LGBT+: Gyms and Spas" },
  { name: "LGBT+: Shopping", id: "LGBT+: Shopping" },
  { name: "LGBT+: Where to Stay", id: "LGBT+: Where to Stay" },
  { name: "Multicultural: Dining", id: "Multicultural: Dining" },
  { name: "Multicultural: Nightlife", id: "Multicultural: Nightlife" },
  { name: "Nightlife", id: "Nightlife" },
  { name: "Pet-Friendly", id: "Pet-Friendly" },
  { name: "Restaurants", id: "Restaurants" },
  { name: "Shopping", id: "Shopping" },
  { name: "Spas", id: "Spas" },
  { name: "Sports", id: "Sports" },
  { name: "Transportation", id: "Transportation" },
  { name: "Venues", id: "Venues" },
  { name: "Waterways", id: "Waterways" },
  { name: "Ways to Play", id: "Ways to Play" },
  { name: "Wedding Locations", id: "Wedding Locations" },
  { name: "Wedding Vendors", id: "Wedding Vendors" },
];

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 26.77348549524911,
      lat2: 25.46774247787312,
      lon1: -79.86128250585939,
      lon2: -80.41334549414064,
      loading: false,
      query: "",
      category: [],
      width: null,
      mobile: false,
      source: false,
      zoom: 10,
      center: {
        lat: 26.122438,
        lng: -80.137314,
      },
      color: "0096bb",
      font: "Source Sans Pro",
      userInfo: "",
      options: [
        { name: "Arts & Entertainment", id: "category" },
        { name: "Convention Services", id: "category" },
        { name: "Diving & Snorkeling", id: "category" },
        { name: "Film", id: "category" },
        { name: "FitLauderdale", id: "category" },
        { name: "Hotels", id: "category" },
        { name: "LGBT+: Gyms and Spas", id: "category" },
        { name: "LGBT+: Shopping", id: "category" },
        { name: "LGBT+: Where to Stay", id: "category" },
        { name: "Multicultural: Dining", id: "category" },
        { name: "Multicultural: Nightlife", id: "category" },
        { name: "Nightlife", id: "category" },
        { name: "Pet-Friendly", id: "category" },
        { name: "Restaurants", id: "category" },
        { name: "Shopping", id: "category" },
        { name: "Spas", id: "category" },
        { name: "Sports", id: "category" },
        { name: "Transportation", id: "category" },
        { name: "Venues", id: "category" },
        { name: "Waterways", id: "category" },
        { name: "Ways to Play", id: "category" },
        { name: "Wedding Locations", id: "category" },
        { name: "Wedding Vendors", id: "category" },
      ],
      filterOpen: false,
      showDirectoryHeader: true,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  static computeShowDirectoryHeader(params, mobile) {
    const headerParam = params.get("header");
    if (headerParam === "true") return true;
    if (headerParam === "false") return false;
    return !mobile;
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    const mobile = Boolean(params.get("mobile"));
    const source = parseQueryBool(params.get("source"));
    const showDirectoryHeader = DirectoryView.computeShowDirectoryHeader(
      params,
      mobile
    );

    this.setState({
      mobile,
      width,
      source,
      showDirectoryHeader,
    });

    if (width < 800) {
      this.getHotelsList();
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true });
    setTimeout(() => {
      const { lat1, lat2, lon1, lon2, query, category } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 10,
      center: {
        lat: 26.124161,
        lng: -80.143593,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
        "*"
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travproconnect.com/profile/${userInfoID}?app_id=1795`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=1795`,
      });
    }
  };

  freeInfo = (userInfoID) => {
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=812&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        "*"
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=812&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=812&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
      });
    }
  };

  onSelect(selectedList, selectedItem) {
    this.setState(
      {
        [selectedItem.id]: [
          ...this.state[selectedItem.id],
          selectedItem["name"],
        ],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem["name"]);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState(
        {
          [removedItem.id]: array,
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  }

  handleCheck = (e) => {
    if (this.state.category.includes(e.target.id)) {
      let filteredArray = this.state.category.filter(
        (item) => item !== e.target.id
      );
      this.setState(
        {
          category: filteredArray,
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      if (e.target.id !== "") {
        this.setState(
          {
            category: this.state.category.concat([e.target.id]),
          },
          () => {
            this.getHotelsList();
          }
        );
      }
    }
  };

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      source,
      width,
      loading,
      filterOpen,
      showDirectoryHeader,
    } = this.state;

    const directoryClassName = [
      "directoryContainer",
      showDirectoryHeader ? "" : "directoryContainer--noDirectoryHeader",
      mobile ? "directoryContainer--mobile" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={directoryClassName}>
        {(mobile || source) && (
          <style>{".cookieConsent { display: none !important; }"}</style>
        )}
        {mobile && (
          <style>
            {
              ".backLink { display: none; } .directoryContainer.directoryContainer--mobile { height: 100vh; } .directoryContainer .directoryView .leftSide .results { top: 0 !important; } .directoryContainer .directoryView .leftSide .leftGrid .listContainer .directorySearchBar { top: 8.3rem !important; }"
            }
          </style>
        )}
        {showDirectoryHeader && (
          <div className="header">
            {!source && (
              <BackButton
                useHistory={false}
                text={i18n.translate("general.back")}
              />
            )}
            <img
              src="https://front.travpromobile.com/1795/1773333775-lauderdalelocalcolorwhitestackedlogo.png"
              className="logo"
              alt="logo"
            />
          </div>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directoryView.amountOfResults")}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate("general.close")
                  : i18n.translate("directoryView.filter")}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                <div className="type">
                  <Multiselect
                    options={this.state.options}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder="Filter by Category"
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className="island">
                  <Multiselect
                    options={this.state.islandOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder="Filter by Island"
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className="price">
                  <Multiselect
                    options={this.state.priceOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder="Filter by Price"
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className="checkboxOptions">
                  <span className="title">
                    {i18n.translate("directoryView.filters")}
                  </span>
                  {checkboxOptions.map((option, index) => (
                    <div
                      key={index}
                      className="checkboxDiv"
                      id={option.id}
                      onClick={this.handleCheck}
                    >
                      <label id={option.id} onClick={this.handleCheck}>
                        <span
                          className="labelName"
                          id={option.id}
                          onClick={this.handleCheck}
                        >
                          {i18n.translate(
                            `directory.${option.name
                              .replace(/\s/g, "")
                              .replace(/&/g, "")
                              .replace(/,/g, "")
                              .replace(/&/g, "")
                              .replace(/,/g, "")
                              .replace(/-/g, "")
                              .replace("+", "")
                              .replace(/:/g, "")
                              .toLowerCase()}`
                          )}
                        </span>
                        <input
                          type="checkbox"
                          name={option.name}
                          onChange={this.handleCheck}
                        />
                        <span
                          className="checkmark"
                          id={option.id}
                          onClick={this.handleCheck}
                        />
                      </label>
                    </div>
                  ))}
                </div>
                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directoryView.resetFilters")}
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directoryView.resetFilters")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directoryView.showResults")}
                  </button>
                </div>
              </div>

              <div
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="directorySearchBar">
                  <FontAwesomeIcon
                    icon={["fas", "search"]}
                    className="searchIcon"
                  />
                  <input
                    className="searchInput"
                    placeholder={i18n.translate("directoryView.search")}
                    type="text"
                    ref={(input) => (this.search = input)}
                    onChange={this.handleInputChange}
                  />
                </div>
                <SimpleBarReact className="listContainerScroll">
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        mobile={mobile}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directoryView.noResults")}
                    </div>
                  )}
                  {/* Filter duplicates, because items are created for each category and can't have multiple */}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel, i) => (
                      <React.Fragment key={hotel.company_listing_id}>
                        {i !== 0 &&
                          freeHotelsList[i - 1].company !== hotel.company && (
                            <FreeHotel
                              id={hotel.company_listing_id}
                              bgImage={hotel.img_path + hotel.photo_file}
                              flyToMarker={() => {
                                this.flyToMarker(
                                  hotel.latitude,
                                  hotel.longitude
                                );
                              }}
                              hotelInfo={() => {
                                this.freeInfo(hotel.listing_id);
                              }}
                              hotelName={hotel.company}
                              location={hotel.state}
                              item={hotel}
                            />
                          )}
                        {freeHotelsList.length === 1 && (
                          <FreeHotel
                            id={hotel.company_listing_id}
                            bgImage={hotel.img_path + hotel.photo_file}
                            flyToMarker={() => {
                              this.flyToMarker(hotel.latitude, hotel.longitude);
                            }}
                            hotelInfo={() => {
                              this.freeInfo(hotel.listing_id);
                            }}
                            hotelName={hotel.company}
                            location={hotel.state}
                            item={hotel}
                          />
                        )}
                      </React.Fragment>
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {i18n.translate("directoryView.resetMap")}
                    </div>
                  )}
                </div>
                </SimpleBarReact>
              </div>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("general.back")}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
